import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Redirect, withRouter } from 'react-router-dom';
import { isAuthenticated as isAuthenticatedProperty } from '../../../reducers/currentUser/currentUser.reducer';

const DONT_REDIRECT_ROUTES = ['/login'];

export const LoggedInChecker = ({ isAuthenticated, location: { pathname } }) => (
  <span>
    {!isAuthenticated && !DONT_REDIRECT_ROUTES.includes(pathname) && <Redirect to="/login" />}
  </span>
);

LoggedInChecker.defaultProps = {
  location: {},
};

LoggedInChecker.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  location: PropTypes.shape({}),
};

export const mapStateToProps = state => ({
  isAuthenticated: isAuthenticatedProperty(state),
});

export const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(LoggedInChecker));



// WEBPACK FOOTER //
// ./src/components/Login/LoggedInChecker/LoggedInChecker.jsx